export const MAX_PIN_SPACES = 25;
